export default "__VITE_PUBLIC_ASSET__fd58cd75__"